import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const cvShare = {
  // 获取加密简历的简历token
  getEncodedToken: (token, payload) => {
    return api.get(proxyApi + `/v3/share_cvs/${token}/encoded_token`, payload)
  },
  // 获取分享简历单人权限事件
  getAuthorityByToken: (cvToken, cvAccountToken) => {
    return api.get(proxyApi + `/v3/share_cvs/${cvToken}/auths/${cvAccountToken}`, {})
  },
  // 修改分享简历单人权限事件
  updateAuthorityByToken: (cvToken, cvAccountToken, payload) => {
    return api.put(proxyApi + `/v3/share_cvs/${cvToken}/auths/${cvAccountToken}`, payload)
  },
  // 获取分享简历用户列表
  getAuthsByToken: (token, payload) => {
    return api.get(proxyApi + `/v3/share_cvs/${token}/auths`, payload)
  },
  // 修改分享简历的设置
  updateShareCvSettings: (token, payload) => {
    return api.put(proxyApi + `/v3/share_cvs/${token}/settings`, payload)
  },
  // 获取分享简历的设置
  getShareCvSettings: token => {
    return api.get(proxyApi + `/v3/share_cvs/${token}/settings`, {})
  },
  // 更新分享简历单人查看时间
  updateShareCvViewed: token => {
    return api.put(proxyApi + `/v3/share_cvs/${token}/viewed`, {})
  },
  // 获取owner查看访问列表时间
  getOwnerViewListTime: (cvToken, cvAccountToken) => {
    return api.get(proxyApi + `/v3/share_cvs/${cvToken}/view/${cvAccountToken}`, {})
  },
  // 修改owner查看访问列表时间
  updateOwnerViewListTime:  (cvToken, cvAccountToken) => {
    return api.put(proxyApi + `/v3/share_cvs/${cvToken}/view/${cvAccountToken}`, {})
  },
  // 获取分享简历 加密token
  getCvEncodedToken: (cv_token, params) => {
    return api.get(proxyApi + `/v3/share_cvs/${cv_token}/encoded_token`, params)
  }
}
export default cvShare
